import React from 'react';

const GiftTileSkeleton = () => {
  return (
    <div className="grid grid-cols-2 xl:grid-cols-3 gap-3 mt-2">
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
      <div className="h-32 shadow-md rounded-md bg-giveGray-200 text-center border-slate-300 border-solid border cursor-pointer animate-[pulse_1s_ease-in-out_infinite]"></div>
    </div>
  );
};

export default GiftTileSkeleton;
